import { cn } from "@/lib/utils";
import { UserOnlineStatus } from "@/types";

type Props = {
	status: UserOnlineStatus;
	className?: string;
};

export function getUserFacingClientSupportStatus(
	lauraPaused?: boolean | null,
): UserOnlineStatus {
	return lauraPaused ? UserOnlineStatus.AWAY : UserOnlineStatus.ONLINE;
}

const STATUS_COLOR_MAP: Record<UserOnlineStatus, string> = {
	[UserOnlineStatus.ONLINE]: "var(--color-brand-secondary)", // #3FE0D0 - Secondary Aqua (teal)
	[UserOnlineStatus.AWAY]: "var(--color-warning)",
	[UserOnlineStatus.BUSY]: "var(--color-error)",
	[UserOnlineStatus.OFFLINE]: "var(--color-text-muted)",
	[UserOnlineStatus.OUT_OF_OFFICE]: "var(--color-text-muted)",
	[UserOnlineStatus.ON_ANNUAL_LEAVE]: "var(--color-text-muted)",
};


export default function StatusMarker({ status, className }: Props) {
	const normalizedStatus = status as UserOnlineStatus;
	const backgroundColor = STATUS_COLOR_MAP[normalizedStatus] ?? "var(--color-text-muted)";
	
	return (
		<div
			className={cn("size-3.5 rounded-full z-20", className)}
			style={{ backgroundColor: backgroundColor as string }}
		/>
	);
}